import React, {useState} from "react";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button, Form } from 'react-bootstrap';
import axios from "axios";

const VerticalContactBar = ({showApModelSidebar}) =>{

    const navigate = useNavigate();

    const callingno = "+919871150032";
    const whatsapp = "919810014747";
    const apiEndPoint = "/api/enquiry";

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(null);
    const [errname, setErrName] = useState(false);
    const [erremail, setErrEmail] = useState(false);
    const [errphone, setErrPhone] = useState(false);
    const [errmessage, setErrMessage] = useState(false);


    const handleName = (e) =>{
        //console.log(e.target.value);
        setName(e.target.value);
    }

    const handleEmail = (e) =>{
        setEmail(e.target.value);
    }

    const handlePhone = (e) =>{
        setPhone(e.target.value);
    }

    const handleMessage = (e) =>{
        setMessage(e.target.value);
    }

    const handleClose = () =>{
        setShow(false);
    }

    const handleEnquirySubmission = async (event) =>{
        event.preventDefault();

        let formerror = false;

        if(name == "")
        {
            setErrName(true);
            formerror = true;
        }
        if(email == "")
        {
            setErrEmail(true);
            formerror = true;
        }
        if(phone == "")
        {
            setErrPhone(true);
            formerror = true;
        }
        if(message == "")
        {
            setErrMessage(true);
            formerror = true;
        }
        if(formerror === true)
        {
            return false;
        }
        else
        {
            console.log('Form true');

            const formData = new FormData();
            formData.append("name", name);
            formData.append("email", email);
            formData.append("phone", phone);
            formData.append("message", message);

            try 
            {
                const response = await axios.post("https://entdelhi.com/mailer/enquiry.php", formData);

                if (response.data.code === 200) 
                {
                    //setStatus("Message sent successfully!");
                    setFeedback({ type: 'success', msg: 'Enquiry has been submitted successfully' });
                    setName("");
                    setEmail("");
                    setPhone("");
                    setMessage("");

                    setShow(false);

                    navigate("/thank-you");
                } 
                else if(response.data.code === 203)
                {
                    //setStatus("Failed to send message.");
                    setFeedback({ type: 'success', msg: 'Mail not sent.' });
                    console.error(response.data.message);
                }
                else if(response.data.code === 205)
                {
                    //setStatus("Failed to send message.");
                    setFeedback({ type: 'success', msg: 'Form error.' });
                    console.error(response.data.message);
                }
                else if(response.data.code === 206)
                {
                    //setStatus("Failed to send message.");
                    setFeedback({ type: 'success', msg: 'Method invalid.' });
                    console.error(response.data.message);
                }

                //setIsSubmit(false);
            } 
            catch (error) 
            {
                //setStatus("Something went wrong!");
                setFeedback({ type: 'success', msg: 'Catch error' });
                console.error("Axios error:", error);
            }
        }
    }

    const whatsappurl = `https://wa.me/${whatsapp}?text=${encodeURIComponent("Hi, I am contacting regarding an enquiry.")}`;    

    return(
    <>        
        <div className="vcb-container" aria-hidden={show ? "true" : "false"}>
            <div className="social-share">
                <Link to={`tel:${callingno}`} className="icon ">
                    <i className="fa-solid fa-phone me-4"></i>Call now
                </Link>
                <Link to={whatsappurl} className="icon" target="_blank">
                    <i className="fa-brands fa-whatsapp me-4"></i>Connect us
                </Link>
                <button type="button" className="icon ft-16" onClick={showApModelSidebar} aria-label="Open enquiry form">
                    <i className="fa-solid fa-headset me-4"></i>Enquire now
                </button>
            </div>
            
        </div>

      
        
            <Modal show={show} onHide={handleClose} className="vcb-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Enquire Now</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                        <Form.Floating className="mb-3">
                            <Form.Control type="text" id="floatingInputName" placeholder="Name" value={name} onChange={handleName} className={errname ? 'input-error' : ''} />
                            <label htmlFor="floatingInputName">Enter Name</label>
                        </Form.Floating>
                        <Form.Floating className="mb-3">
                            {/*<Form.Label>Email</Form.Label>*/}
                            <Form.Control type="email" id="floatingInputEmail" placeholder="Email" value={email} onChange={handleEmail} className={erremail ? 'input-error' : ''} />
                            <label htmlFor="floatingInputEmail">Enter Email</label>
                        </Form.Floating>
                        <Form.Floating className="mb-3">
                            {/*<Form.Label>Mobile</Form.Label>*/}
                            <Form.Control type="text"  id="floatingInputPhone" placeholder="Mobile" value={phone} onChange={handlePhone} className={errphone ? 'input-error' : ''} />
                            <label htmlFor="floatingInputPhone">Enter Phone</label>
                        </Form.Floating>
                        <Form.Floating className="mb-3">
                            {/*<Form.Label>Message</Form.Label>*/}
                            <Form.Control as="textarea" id="floatingInputMessage" rows={3} placeholder="Message" onChange={handleMessage} className={errmessage ? 'input-error' : ''} />
                            <label htmlFor="floatingInputMessage">Enter Message</label>
                        </Form.Floating>
                        
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="button" onClick={handleEnquirySubmission}> Submit </Button>
                    <Button variant="secondary" onClick={handleClose}> Close </Button>
                </Modal.Footer>
            </Modal>
        
    
        
      </>
    )
}

export default VerticalContactBar;
